<template>
    <div class="todo-container">
        <div class="todo-header">
            <span class="todo-header-label">{{ todoData.label }}</span>
            <span class="todo-header-icon" :class="todoData.iconClass"></span>
        </div>
        <div class="todo-wrap">
            <div class="todo-content">
                <div
                    class="todo-content-item"
                    :class="'bigData-btn-todo-'+item.code"
                    v-for="item in todoData.childList"
                    v-has="item.auth"
                    @click="onTodoView(item)"
                    :key="item.code"
                >
                    <span class="todo-content-item-top">{{ item.label }}
                        <el-tooltip v-if="item.info" class="item" effect="dark" placement="top">
                            <div slot="content" v-html="item.info"></div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </span>
                    <span class="todo-content-item-bottom">
                        <div class="todo-content-item-params">
                            <span class="todo-content-item-val">{{
                                item.value===0?0:item.value||'&nbsp;&nbsp;'
                            }}</span>
                            <span class="todo-content-item-unit">{{
                                item.unit
                            }}</span>
                        </div>

                        <i class="todo-content-item-arrow arrow-icon"></i>
                    </span>
                </div>
            </div>
            <div class="todo-footer" v-if="isConfig">
                <i
                    class="todo-footer-btn delete-icon"
                    @click="onDelte(todoData)"
                ></i>
                <i class="todo-footer-btn move-icon"></i>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-magic-numbers */
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['user'])
    },
    props: {
        todoData: {
            type: Object,
            default() {
                return {
                    title: '',
                    code: 'transportTodo',
                    iconClass: 'finance-icon',
                    childList: []
                };
            }
        },
        isConfig: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
        };
    },
    methods: {
        onDelte(params) {
            this.$emit('on-delete', params);
        },
        onTodoView(params) {
            this.$emit('on-todo-view', params);
        }
    }
};
</script>
<style lang="less" scoped>
.arrow-icon {
    background: url(../img/arrow-right@2x.png) no-repeat;
    background-size: 100%;
}
.todo {
    &-container {
        padding: 24px 24px 8px;
        // width: 244px;
        // height: 330px;
        // height: 418px;
        width: calc(100% - 48px);
        background: #ffffff;
        border-radius: 4px;
    }
    &-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        &-label {
            // width: 56px;
            height: 24px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #1d2129;
            line-height: 24px;
        }
        &-icon {
            display: inline-block;
            width: 48px;
            height: 48px;
            margin-bottom: 16px;
        }
        .transport-icon {
            background: url(../img/transport.png) no-repeat;
            background-size: 100%;
        }
        .finance-icon {
            background: url(../img/finance.png) no-repeat;
            background-size: 100%;
        }
        .operate-icon {
            background: url(../img/operate.png) no-repeat;
            background-size: 100%;
        }
        .achievements-icon {
            background: url(../img/achievements.png) no-repeat;
            background-size: 100%;
        }
    }
    &-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // height: calc(100% - 87px);
        height: calc(100% - 87px);
        // border: 1px solid brown;
    }
    &-content {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        height: 282px;
        &-item {
            display: flex;
            flex-direction: column;
            padding: 12px 12px 8px 12px;
            width: calc(50% - 35px);
            height: 52px;
            background: #f7f8fa;
            border-radius: 2px;
            font-family: PingFangSC-Regular, PingFang SC;
            border: 1px solid #f7f8fa;
            margin: 0 16px 16px 0;
            cursor: pointer;

            &:hover {
                background: #e5f0fe;
                border: 1px solid #2881ff;
                .todo-content-item-arrow {
                    display: inline-block;
                }
            }
            &:nth-child(even) {
                margin-right: 0;
            }
            &-top {
                // width: 36px;
                height: 20px;
                font-size: 12px;
                font-weight: 400;
                color: #4e5969;
                line-height: 20px;
            }
            &-bottom {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            &-params {
                position: relative;
                display: flex;
                align-items: baseline;
            }
            &-val {
                height: 32px;
                font-size: 24px;
                font-weight: 600;
                color: #1d2129;
                line-height: 32px;
            }
            &-unit {
                height: 20px;
                font-size: 12px;
                font-weight: 400;
                color: #4e5969;
                line-height: 20px;
                margin-left: 4px;
            }
            &-arrow {
                position: absolute;
                width: 6px;
                height: 10px;
                top: 16px;
                right: -1px;
                color: #2881ff;
                display: none;
            }
        }
    }
    &-footer {
        display: flex;
        justify-content: flex-end;
        background-color: #ffffff;
        margin: 21px 0 21px 0;
        // border: 1px solid blue;
        &-btn {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 22px;
            &:last-child {
                margin-right: 0;
            }

            &:hover {
                opacity: 0.9;
            }
            &:active {
                opacity: 0.6;
            }
        }
        .delete-icon {
            background: url(../img/delete.png) no-repeat;
            background-size: 100%;
            cursor: pointer;
        }
        .move-icon {
            background: url(../img/move-outline.png) no-repeat;
        }
    }
}
</style>
